import { useState, useEffect } from "react";
import { InventoryStockResponse } from "../../Interfaces/Warehouse";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";
import "./InventoryStock.css";
import { useNavigate } from "react-router/dist";
import UpdateInventoryStock from "./UpdateInventoryStock";

const InventoryStockDisplay = () => {
  const [inventoryStock, setInventoryStock] = useState<
    InventoryStockResponse[]
  >([]);

  useEffect(() => {
    const fetchInventoryStock = async () => {
      try {
        const response = await fetchWithAuth(
          `${config.API_BASE_URL}inventory-stock/stock-counts/`,
        );

        if (response.status === 200) {
          const data = await response.json();
          setInventoryStock(data);
        } else {
          console.error("Failed to fetch inventory stock:", response.status);
        }
      } catch {
        console.log("Failed to fetch inventory stock");
      }
    };
    fetchInventoryStock();
    document.title = "MamFam Inventory Stock";
  }, []);

  const [showPopup, setShowPopup] = useState(false);
  const openPopup = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);
  const navigate = useNavigate();
  const viewAllPendingOrdersButtonClick = () => {
    navigate("/warehouse/orders/");
  };

  return (
    <div className="inventory-container">
      <button onClick={viewAllPendingOrdersButtonClick}>
        View all Pending Orders
      </button>
      <button onClick={() => openPopup()}>Edit Inventory </button>

      <h1 className="inventory-title">Current Inventory</h1>
      <div className="table-wrapper">
        <table className="inventory-table">
          <thead>
            <tr>
              <th>SKU</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {inventoryStock.map((inventory, index) => (
              <tr key={index}>
                <td>{inventory.sku}</td>
                <td>{inventory.name}</td>
                <td>{inventory.quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showPopup && <UpdateInventoryStock onClose={closePopup} />}
    </div>
  );
};

export default InventoryStockDisplay;
